
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface ResultsHandlerProps {
  resultsCountry: string | null;
  resultsLeague: string | null;
}

const ResultsHandler: React.FC<ResultsHandlerProps> = ({
  resultsCountry,
  resultsLeague,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (resultsCountry && resultsLeague) {
      navigate('/results', {
        state: {
          filterByLeague: true,
          country: resultsCountry,
          league: resultsLeague,
          loadLatestForLeague: true
        }
      });
    }
  }, [resultsCountry, resultsLeague, navigate]);

  return null; // This is a utility component with no UI
};

export default ResultsHandler;
